module.exports = __webpack_public_path__ + "img/th-wildau-logo.59c94783.png";